// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3S0Y9","content":"GlobalSearch_content__1rK59"};